import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LvrenNote from './lvRenNote';
import Banner from './banner';

class content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const { bannerPic, lvrenNoteTab, linkFengUrl, lvrenNote } = content;
        const lvrenNoteData = {
            lvrenNoteTab,
            linkFengUrl,
            lvrenNote,
        };

        return (
            <div className={styles.content}>
                <Chip
                    id="60054"
                    type="recommend"
                    title="banner轮播图"
                    groupName="正文"
                    content={bannerPic}
                    translate="handleLvrenBannerPicData">
                    <Banner />
                </Chip>

                <LvrenNote content={lvrenNoteData} />
            </div>
        );
    }
}

export default errorBoundary(content);
